<div class="course-item">
    <div class="media">
        <figure *ngIf="courseImage$ | async as courseImage">
            <da-progressive-image
                [options]="{
                    alt: alt,
                    aspectRatios: [
                        {
                            breakpoint: 360,
                            width: 480,
                            height: 320,
                            akamaiImage: courseImage
                        },
                        {
                            breakpoint: 480,
                            width: 780,
                            height: 520,
                            akamaiImage: courseImage
                        },
                        {
                            breakpoint: 768,
                            width: 480,
                            height: 320,
                            akamaiImage: courseImage
                        },
                        {
                            breakpoint: 960,
                            width: 380,
                            height: 253,
                            akamaiImage: courseImage
                        },
                        {
                            breakpoint: 1120,
                            width: 480,
                            height: 320,
                            akamaiImage: courseImage
                        }
                    ]
                }"
            ></da-progressive-image>
        </figure>
    </div>
    <div class="content-part">
        <div class="inner-content inner-item">
            <div class="content-card">
                <div class="content-lg">
                    <div class="headline main-title main-title-quick">
                        <h6>
                            {{ courseTitle }}
                            <span class="last-word">
                                {{ lastWord }}                                                        
                                <span
                                    class="label-bestseller"
                                    *ngIf="course.keyWords && course.keyWords.length > 0"
                                    [innerHTML]="course.keyWords[0]"
                                ></span>
                            </span>
                        </h6>
                    </div>
                    <!-- <p *ngIf="!course.training.descriptionShort">&nbsp;</p> -->
                </div>
            </div>
        </div>
        <div class="details">
            <div class="inner-wrapper">
                <div class="wrapper" *ngIf="!course.url && course.isProduct">
                    <div class="wrapper" [innerHTML]="'courses.online' | translate"></div>
                </div>

                <div class="wrapper" *ngIf="!course.url && !course.isProduct">
                    <div class="wrapper" *ngIf="course.productType === 'SEM' || course.productType === 'WRK'" [innerHTML]="'courses.presence' | translate"></div>
                    <div class="wrapper" *ngIf="course.productType === 'WBN'" [innerHTML]="'courses.virtual' | translate"></div>
                    <div *ngIf="course.duration" class="separator">/</div>
                    <div *ngIf="course.duration" class="duration"></div>
                </div>
            </div>
            <div class="price" *ngIf="course.prices.length > 0 && ( course.metadata === null || !course.metadata || course.metadata.showPrice)">
                <span [innerHTML]="'courses.price' | translate"></span>
                <br *ngIf="course.prices.length > 1 && course.prices[1].value > course.prices[0].value" />
                <span *ngIf="course.prices.length === 1 || course.prices.length > 1 && course.prices[1].value === course.prices[0].value"> {{ formattedPrice$ | async }}</span>
                <span *ngIf="course.prices.length > 1 && course.prices[1].value > course.prices[0].value && course.prices[0].value > 0">{{ formattedPrice$ | async }} - {{ formattedPrice2$ | async }}</span>
                <span *ngIf="course.prices.length > 1 && course.prices[1].value > course.prices[0].value && course.prices[0].value === 0">{{ formattedPrice2$ | async }}</span>
                <span [innerHTML]="'common.perPerson' | translate"></span>
                <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
            </div>
            <div class="price" *ngIf="course.price !== undefined && course.prices.length === 0 && ( course.metadata === null || !course.metadata || course.metadata.showPrice)">
                <span [innerHTML]="'courses.price' | translate"></span>
                <span> {{ formattedPrice$ | async }}</span>
                <span [innerHTML]="'common.perPerson' | translate"></span>
                <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
            </div>
            <div class="price" *ngIf="course.metadata && !course.metadata.showPrice">
                <span [innerHTML]="'courses.noPrice' | translate"></span>
            </div>
        </div>
        <div class="button-container">
            <div class="button-wrapper quick-view">
                <a da-link [routerLink]="courseDetail" class="secondary button" [innerHTML]="'buttons.showDetails' | translate" (click)="goToSimilarCourse()"></a>
            </div>
        </div>
    </div>
</div>
